import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
import { MapPin } from 'lucide-react';
interface HeroProps {
  onBook: () => void;
  lang: 'en' | 'es';
}
export function Hero({
  onBook,
  lang
}: HeroProps) {
  return <section className="relative min-h-screen flex flex-col justify-center items-center overflow-hidden" data-id="element-121">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-122">
        <img src="https://images.unsplash.com/photo-1560066984-138dadb4c035?q=80&w=2000&auto=format&fit=crop" alt="Luxury Salon Interior" className="w-full h-full object-cover object-center" data-id="element-123" />
        <div className="absolute inset-0 bg-brand-dark/50" data-id="element-124"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/30 via-transparent to-brand-dark/80" data-id="element-125"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 flex flex-col items-center text-center pt-40 md:pt-48 pb-12" data-id="element-126">
        <FadeIn delay={0.2} direction="none" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/jbeNRpnSsmFDcYRPuthdxF/imagen_regenerada_1.png" alt="ISASHY Beauty Center Logo" className="w-72 md:w-96 lg:w-[28rem] object-contain mb-12 drop-shadow-[0_0_30px_rgba(201,168,76,0.3)]" data-id="element-128" />
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-129">
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-brand-cream leading-[1.1] mb-8 max-w-4xl" data-id="element-130">
            {lang === 'es' ? <>
                Entra Cansada.
                <br data-id="element-131" />
                <span className="italic text-brand-gold" data-id="element-132">
                  Sal Transformada.
                </span>
                <br data-id="element-133" />
                Esa es la Promesa ISASHY.
              </> : <>
                Walk In Tired.
                <br data-id="element-134" />
                <span className="italic text-brand-gold" data-id="element-135">
                  Walk Out Transformed.
                </span>
                <br data-id="element-136" />
                That's the ISASHY Promise.
              </>}
          </h1>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-137">
          <div className="flex items-center justify-center gap-2 text-brand-cream/90 font-sans text-sm md:text-base mb-12" data-id="element-138">
            <MapPin className="w-4 h-4 text-brand-gold" data-id="element-139" />
            <p data-id="element-140">1407 North Main St, Waterbury, CT 06704</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.8} data-id="element-141">
          <button onClick={onBook} className="bg-brand-gold hover:bg-brand-gold/90 text-brand-dark px-8 py-4 rounded-none font-sans font-medium tracking-wide transition-all duration-300 transform hover:-translate-y-1" data-id="element-142">
            {lang === 'es' ? 'Reserva Tu Transformación' : 'Book Your Transformation'}
          </button>
        </FadeIn>
      </div>
    </section>;
}